import { Typography } from 'antd';
import React, { ReactNode, useEffect, useState } from 'react';
import { ReactComponent as BackButton } from '../../../Assets/left-arrow.svg';
import styles from './NavigationHeader.module.css';

interface Props {
  header?: string;
  onBack: () => void;
  img?: ReactNode;
}

const NavigationHeader: React.FC<Props> = ({ header, onBack, img }) => {
  const { Text } = Typography;
  useEffect(() => {
    window.onpopstate = () => {
      window.history.pushState(null, '', window.location.href);
    };
  }, []);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 18) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    window.scrollTo(0, 0);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <div
        className={styles.backButton}
        style={{
          boxShadow: scrolled ? 'rgba(0, 0, 0, 0.16) 0px 4px 10px' : 'none',
        }}
      >
        <div
          style={{
            height: 24,
            display: 'flex',
            alignItems: 'flex-end',
            gap: 8,
          }}
        >
          <BackButton
            onClick={() => {
              onBack();
            }}
          />
          {img ? (
            <span style={{ display: 'flex', justifyContent: 'center' }}>
              {img}
            </span>
          ) : header ? (
            <Text style={{ fontWeight: 500 }}>{header}</Text>
          ) : null}{' '}
        </div>
      </div>
    </>
  );
};

export default NavigationHeader;
